import { render } from "./RecurrenceFeature.vue?vue&type=template&id=98df51a0&ts=true"
import script from "./RecurrenceFeature.vue?vue&type=script&lang=ts"
export * from "./RecurrenceFeature.vue?vue&type=script&lang=ts"

import "./RecurrenceFeature.vue?vue&type=style&index=0&id=98df51a0&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__